import { Grid, Spacer, Typography } from '@qbe/ads-core';
import React, { useEffect } from 'react';

import { useAppContent, useAppDispatch, useCoverDetails } from '~/hooks';
import { updateTotalCoverValue } from '~/slices/coverDetails';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

interface TotalCoversProps {
  maximumLimit: number;
}

const TotalCovers: React.FC<TotalCoversProps> = ({ maximumLimit }) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.coverDetailsPortableItems',
    tokens: { maximumLimit: () => currencyFormatter(maximumLimit, CurrencyFormat.Comma) },
  });

  const dispatch = useAppDispatch();
  const { totalCoverValue, blanketCovers, specifiedItems } = useCoverDetails();

  useEffect(() => {
    const totalBlanketCovers =
      blanketCovers?.reduce((sum, { value }) => sum + Number(value), 0) ?? 0;
    const totalSpecifiedItems =
      specifiedItems?.reduce((sum, { value }) => sum + Number(value), 0) ?? 0;
    dispatch(updateTotalCoverValue(totalBlanketCovers + totalSpecifiedItems));
  }, [blanketCovers, dispatch, specifiedItems]);

  if (!totalCoverValue) {
    return null;
  }

  // @TODO should be replaced by ADS in future https://qbe-appservices.atlassian.net/browse/AD1-364
  return (
    <>
      <Spacer size="xl" />

      <Grid
        container
        borderTop="1px solid #e1e4e8"
        borderBottom="1px solid #e1e4e8"
        justifyContent="space-between"
        sx={{
          padding: '32px 24px',
          marginBottom: 1,
        }}
      >
        <Grid item>
          <Typography fontWeight="fontWeightBold" component="h4">
            {getTextContent('fields.totalCovers.title')}
          </Typography>
          <Typography color="#000">{getTextContent('fields.totalCovers.description')}</Typography>
        </Grid>
        <Grid
          item
          sx={{
            margin: 'auto 0',
          }}
        >
          <Typography
            fontWeight="fontWeightBold"
            variant="subtitle2"
            component="h4"
            color="#003DA5"
          >
            {currencyFormatter(totalCoverValue, CurrencyFormat.Comma)}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default TotalCovers;
